export const applyPopArtStyle = async (canvas, ctx, setMessage, language) => {
  // 팝 아트: 강렬한 원색과 하프톤 패턴
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = imageData.data;
  
  // 1. 강렬한 원색으로 변환 (워홀 스타일)
  const colors = [
    [255, 0, 0],    // 빨강
    [255, 255, 0],  // 노랑
    [0, 255, 0],    // 초록
    [0, 255, 255],  // 시안
    [0, 0, 255],    // 파랑
    [255, 0, 255],  // 마젠타
    [255, 128, 0],  // 오렌지
    [128, 0, 255]   // 보라
  ];
  
  for (let i = 0; i < data.length; i += 4) {
    const r = data[i];
    const g = data[i + 1];
    const b = data[i + 2];
    
    // 가장 가까운 팝 아트 색상 찾기
    let closestColor = colors[0];
    let minDistance = Infinity;
    
    for (const color of colors) {
      const distance = Math.sqrt(
        Math.pow(r - color[0], 2) +
        Math.pow(g - color[1], 2) +
        Math.pow(b - color[2], 2)
      );
      
      if (distance < minDistance) {
        minDistance = distance;
        closestColor = color;
      }
    }
    
    data[i] = closestColor[0];
    data[i + 1] = closestColor[1];
    data[i + 2] = closestColor[2];
  }
  
  ctx.putImageData(imageData, 0, 0);
  
  // 2. 하프톤 패턴 추가
  const halftoneData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const halftonePixels = halftoneData.data;
  
  const dotSize = 4;
  for (let y = 0; y < canvas.height; y += dotSize * 2) {
    for (let x = 0; x < canvas.width; x += dotSize * 2) {
      // 영역의 평균 밝기 계산
      let avgBrightness = 0;
      let count = 0;
      
      for (let dy = 0; dy < dotSize * 2 && y + dy < canvas.height; dy++) {
        for (let dx = 0; dx < dotSize * 2 && x + dx < canvas.width; dx++) {
          const pos = ((y + dy) * canvas.width + (x + dx)) * 4;
          avgBrightness += (data[pos] + data[pos + 1] + data[pos + 2]) / 3;
          count++;
        }
      }
      
      avgBrightness /= count;
      
      // 밝기에 따라 점 크기 결정
      const dotRadius = (1 - avgBrightness / 255) * dotSize;
      
      // 점 그리기
      const centerX = x + dotSize;
      const centerY = y + dotSize;
      
      for (let dy = -dotSize; dy <= dotSize && centerY + dy >= 0 && centerY + dy < canvas.height; dy++) {
        for (let dx = -dotSize; dx <= dotSize && centerX + dx >= 0 && centerX + dx < canvas.width; dx++) {
          const distance = Math.sqrt(dx * dx + dy * dy);
          if (distance <= dotRadius) {
            const pos = ((centerY + dy) * canvas.width + (centerX + dx)) * 4;
            halftonePixels[pos] = 0;
            halftonePixels[pos + 1] = 0;
            halftonePixels[pos + 2] = 0;
          }
        }
      }
    }
  }
  
  ctx.putImageData(halftoneData, 0, 0);
  
  // 3. 강한 윤곽선 추가
  ctx.strokeStyle = 'black';
  ctx.lineWidth = 2;
  
  const edgeData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const edgePixels = edgeData.data;
  
  for (let y = 1; y < canvas.height - 1; y++) {
    for (let x = 1; x < canvas.width - 1; x++) {
      const pos = (y * canvas.width + x) * 4;
      
      const current = (halftonePixels[pos] + halftonePixels[pos + 1] + halftonePixels[pos + 2]) / 3;
      const right = (halftonePixels[pos + 4] + halftonePixels[pos + 5] + halftonePixels[pos + 6]) / 3;
      const bottom = (halftonePixels[pos + canvas.width * 4] + 
                     halftonePixels[pos + canvas.width * 4 + 1] + 
                     halftonePixels[pos + canvas.width * 4 + 2]) / 3;
      
      if (Math.abs(current - right) > 100 || Math.abs(current - bottom) > 100) {
        edgePixels[pos] = 0;
        edgePixels[pos + 1] = 0;
        edgePixels[pos + 2] = 0;
      }
    }
  }
  
  ctx.putImageData(edgeData, 0, 0);
};